import React from "react";

const WHATSAPP_NUMBER = "917774805226";
const DEFAULT_MSG = encodeURIComponent(
  "Hi Career Connect, I'd like to know more about your services."
);

export default function WhatsAppButton() {
  return (
    <a
      href={`https://wa.me/${WHATSAPP_NUMBER}?text=${DEFAULT_MSG}`}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat with us on WhatsApp"
      data-testid="whatsapp-float-button"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1DA851] text-white shadow-lg flex items-center justify-center transition-transform hover:-translate-y-0.5"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-7 h-7">
        <path d="M20.52 3.48A11.77 11.77 0 0 0 12.06 0C5.52 0 .22 5.3.22 11.84c0 2.09.55 4.13 1.6 5.93L0 24l6.4-1.68a11.78 11.78 0 0 0 5.66 1.44h.01c6.54 0 11.84-5.3 11.84-11.84 0-3.16-1.23-6.14-3.39-8.44ZM12.07 21.4h-.01a9.55 9.55 0 0 1-4.87-1.33l-.35-.21-3.8 1 1.02-3.71-.23-.38a9.57 9.57 0 0 1-1.47-5.12c0-5.3 4.31-9.6 9.62-9.6 2.57 0 4.98 1 6.8 2.82a9.54 9.54 0 0 1 2.82 6.79c0 5.3-4.31 9.6-9.6 9.6Zm5.28-7.18c-.29-.14-1.7-.84-1.97-.94-.27-.1-.47-.14-.67.14s-.76.94-.94 1.13c-.17.19-.35.22-.64.07a7.89 7.89 0 0 1-2.33-1.44 8.76 8.76 0 0 1-1.62-2.02c-.17-.29-.02-.44.13-.58.13-.13.29-.35.43-.52.14-.17.19-.29.29-.48.1-.2.05-.37-.02-.52-.07-.14-.67-1.61-.92-2.2-.24-.58-.48-.5-.67-.51l-.57-.01c-.2 0-.52.07-.79.37-.27.29-1.04 1.02-1.04 2.48 0 1.46 1.07 2.88 1.22 3.07.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.69.63.71.22 1.36.19 1.87.11.57-.08 1.7-.69 1.94-1.36.24-.67.24-1.25.17-1.37-.07-.12-.26-.19-.56-.33Z" />
      </svg>
    </a>
  );
}
